import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { palette, radius } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var Banner = styled(Box).withConfig({
  componentId: "hcuzx3-0"
})(["width:100%;height:100%;position:relative;background-color:", ";border-radius:", ";overflow:hidden;"], palette("neutral.800"), radius("base"));
var Overlay = styled(Box).withConfig({
  componentId: "hcuzx3-1"
})(["position:relative;height:100%;display:flex;flex-direction:column;align-items:flex-start;justify-content:space-between;flex-grow:0;> *{flex-shrink:0;}"]);
var TextWrapper = styled(Box).withConfig({
  componentId: "hcuzx3-2"
})(["display:flex;flex-direction:column;"]);
var Image = styled("img").withConfig({
  componentId: "hcuzx3-3"
})(["position:absolute;width:100%;height:100%;object-fit:cover;"]);
export { Banner, Image, Overlay, TextWrapper };